import React, { useEffect, useRef, useState } from "react";

import { IconChevronDown } from "~/components/icon";
import { cx } from "~/tools/class-variance";

const EXPANDABLE_MAX_HEIGHT_PX = 300;

export const ExpandableContent: React.FC<{ children: React.ReactNode }> = ({ children }) => {
	const contentRef = useRef<HTMLDivElement>(null);
	const [needsTruncation, setNeedsTruncation] = useState(false);
	const [expanded, setExpanded] = useState(false);

	useEffect(() => {
		const el = contentRef.current;
		if (el == null) {
			return;
		}

		const observer = new ResizeObserver(() => {
			setNeedsTruncation(el.scrollHeight > EXPANDABLE_MAX_HEIGHT_PX);
		});
		observer.observe(el);
		return () => observer.disconnect();
	}, []);

	return (
		<div>
			<div
				className={cx(!expanded && needsTruncation && "relative overflow-hidden")}
				ref={contentRef}
				style={!expanded && needsTruncation ? { maxHeight: EXPANDABLE_MAX_HEIGHT_PX } : undefined}
			>
				{children}
				{!expanded && needsTruncation && (
					<div className="pointer-events-none absolute right-0 bottom-0 left-0 h-16 bg-linear-to-t from-white to-transparent" />
				)}
			</div>
			{needsTruncation && (
				<button
					className="mt-1 flex cursor-pointer items-center gap-1 text-grey-400 text-xs hover:text-grey-600"
					data-exclude-copy
					onClick={() => setExpanded((v) => !v)}
					type="button"
				>
					<IconChevronDown className={cx("size-3 transition-transform", expanded ? "" : "-rotate-90")} />
					{expanded ? "See less" : "See more"}
				</button>
			)}
		</div>
	);
};
